import src from "IMAGE";
export default { src, width: 1174, height: 1142 }
